import { FC } from 'react'
import styles from 'components/features/future/FutureLayerPast/CompleteCard/CompleteCard.styl'
import Button from 'components/features/pfm/Button/Button'
import { FutureLayerType } from 'components/features/future/types'

type CompleteCardProps = {
  onAction: () => void
  type: FutureLayerType
}
export const CompleteCard: FC<CompleteCardProps> = (props) => {
  const { children, onAction, type } = props

  return (
    <>
      <div className={ styles.content }>
        { children }
      </div>
      <div className={ styles.editButton }>
        <Button style='textOnly' size='mini' onClick={ onAction }>
          EDIT { type }
        </Button>
      </div>
    </>
  )
}
